import Vue from 'vue';

import {load} from 'recaptcha-v3';

Vue.prototype.$recaptcha = async () => load(
	process.env.RECAPTCHA_SITEKEY || '6LebdLwUAAAAADweEO-gHv-BbMSvNX2dhA5oUvn1', {
		autoHideBadge: true
	});
